import { render, staticRenderFns } from "./ordini.html?vue&type=template&id=03e696ea&scoped=true&"
import script from "./Ordini.vue?vue&type=script&lang=js&"
export * from "./Ordini.vue?vue&type=script&lang=js&"
import style0 from "./Ordini.vue?vue&type=style&index=0&id=03e696ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e696ea",
  null
  
)

export default component.exports